<div class="row card">
    <!-- <div class="image-wrapper">
        <img width="256" height="256" priority placeholder ngSrc="about-me/idris-esen.png" i18n-alt alt="Idris Esen" />
    </div> -->
    <div class="content text-center">
        <h3 class="title" i18n="Not Found">Not Found</h3>
        <p i18n>The page you are looking for does not exist.</p>
        <a class="button button-primary self-center" routerLink="/"><span i18n="Visit Homepage">Visit Homepage</span></a>
    </div>
</div>
